import _plugin_vue_export_helper_default from "../_virtual/_plugin-vue_export-helper.js";
/* empty css                              */
import { createElementBlock, createElementVNode, createTextVNode, openBlock } from "vue";
//#region src/components/BuildingRequest.vue
var _sfc_main = {};
var _hoisted_1 = { class: "buildingRequest" };
function _sfc_render(_ctx, _cache) {
	return openBlock(), createElementBlock("div", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("div", { class: "playIcon" }, [createElementVNode("svg", {
		fill: "currentColor",
		height: "32",
		viewBox: "0 0 256 256",
		width: "32",
		xmlns: "http://www.w3.org/2000/svg"
	}, [createElementVNode("path", { d: "M240,128a15.74,15.74,0,0,1-7.6,13.51L88.32,229.65a16,16,0,0,1-16.2.3A15.86,15.86,0,0,1,64,216.13V39.87a15.86,15.86,0,0,1,8.12-13.82,16,16,0,0,1,16.2.3L232.4,114.49A15.74,15.74,0,0,1,240,128Z" })])], -1), createTextVNode(" Building Request... ", -1)])]);
}
var BuildingRequest_default = /*#__PURE__*/ _plugin_vue_export_helper_default(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-5a1d2b16"]]);
//#endregion
export { BuildingRequest_default as default };

//# sourceMappingURL=BuildingRequest.vue.js.map